import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform 
{
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, ...args: unknown[]): unknown 
  {
    const dynamicHtml = `
    <div>
      <p>${value}</p>
    </div>`
    
    return this.sanitizer.bypassSecurityTrustHtml(dynamicHtml)
  }
}
